import React, { useContext, useEffect, useId } from 'react';
import {
	StyleContext,
	StyleContextData,
} from '../../components/blackrock/advisor-center/style/context.ts';

export function useLocalCSSRule(
	rule: React.CSSProperties,
	deps: React.DependencyList = [],
	prefix = 'id-'
) {
	const { changeCSSProps } = useContext<StyleContextData>(StyleContext);
	const id = prefix + useId().replaceAll(':', '');
	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		changeCSSProps('#' + id, { ...rule });
		return () => {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			changeCSSProps('#' + id, null);
		};
	}, deps);
	return id;
}
